import { render, staticRenderFns } from "./DealPayment.vue?vue&type=template&id=4ef9cb28&scoped=true&"
import script from "./DealPayment.vue?vue&type=script&lang=ts&"
export * from "./DealPayment.vue?vue&type=script&lang=ts&"
import style0 from "./DealPayment.vue?vue&type=style&index=0&id=4ef9cb28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9cb28",
  null
  
)

export default component.exports